import { render, staticRenderFns } from "./WorkspaceAvatar.vue?vue&type=template&id=b7adcefe&"
import script from "./WorkspaceAvatar.vue?vue&type=script&lang=js&"
export * from "./WorkspaceAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports